import axios from 'axios';
import config from '../config';
import { OnboardDeviceStoredLogs } from '../interfaces';

export const getOnboardDeviceLogs = (deviceId: string): Promise<OnboardDeviceStoredLogs> => {
    const url = `${config.API_URL}/onboard-devices/${deviceId}/logs`;

    return axios.get(url).then((response: any) => {
        return response.data;
    });
};
